import { toast } from 'react-toastify'

export const ADD_ERROR = 'ADD_ERROR'
export const REMOVE_ERROR = 'REMOVE_ERROR'
export const ADD_SUCCESS = 'ADD_SUCCESS'
export const REMOVE_SUCCESS = 'REMOVE_SUCCESS'

export const addError = (error) => {
  toast.error(error)
  console.log('show error', error)
  return {
    type: ADD_ERROR,
    error,
  }
}

export const removeError = (error) => {
  return {
    type: REMOVE_ERROR,
    error,
  }
}

export const addSuccess = (message) => {
  toast.success(message)
  return {
    type: ADD_SUCCESS,
    message,
  }
}

export const removeSuccess = (message) => {
  return {
    type: REMOVE_SUCCESS,
    message,
  }
}
